<template>
  <Titlebar
    :root-path="NavigationService.headerMenu?.rootPath || ''"
    :open="open"
    @toggle="handleToggle()"
    v-if="!open"
  ></Titlebar>
  <div class="mmm-mobile-header-login-wrapper">
    <SearchFlyout
      @on-close="showLoginButton = true"
      @on-open="showLoginButton = false"
    ></SearchFlyout>
    <button
      class="mmm-mobile-header-login-wrapper__button"
      @click="showLoginDialog()"
      v-if="showLoginButton"
    >
      Online-Zugänge
    </button>
    <LoginMenu
      :links="loginLinks"
      ref="loginMenuDialog"
      @open="isLoginMenuOpen = true"
      @close="isLoginMenuOpen = false"
    ></LoginMenu>
  </div>
  <Navigation
    :root-path="NavigationService.headerMenu?.rootPath || ''"
    :tree="navigation"
    @toggle="handleToggle()"
    v-if="open"
    ref="navigationRef"
  ></Navigation>
</template>

<script lang="ts" setup>
import { onMounted, ref } from 'vue';

import { NavigationService, SubHeaderNavItemAdapter, type ISubHeaderNavItem } from '../helper';
import Navigation, { type INavigationMobileComponent } from '../mobile/NavigationMobile.ce.vue';
import Titlebar from '../mobile/TitlebarMobile.ce.vue';
import LoginMenu, { type ILoginMenuDialog } from '../shared/LoginMenu.ce.vue';
import SearchFlyout from '../shared/SearchFlyout.ce.vue';

const open = ref(false);
const navigationRef = ref<INavigationMobileComponent | null>(null);
const navigation = ref<ISubHeaderNavItem[]>([]);

const loginMenuDialog = ref<ILoginMenuDialog>();
const isLoginMenuOpen = ref(false);
const loginLinks = NavigationService.loginMenu?.getNavigationTree() || [];

const showLoginButton = ref(true);

function showLoginDialog() {
  loginMenuDialog.value?.show();
}

function handleToggle() {
  open.value = !open.value;
}

onMounted(async () => {
  await NavigationService.whenReady();
  navigation.value =
    NavigationService.headerMenu?.topLevel.map(s => SubHeaderNavItemAdapter.create(s)) || [];
});
</script>

<style lang="scss" scoped>
.mmm-mobile-header-login-wrapper {
  position: fixed;
  top: calc(var(--header-mobile-height) + 1px);
  height: var(--sub-header-mobile-height);
  width: 100%;
  background-color: var(--color-background-background);
  left: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 6px;
  padding: 0 12px;
  box-sizing: border-box;

  &__button {
    padding: 0 28px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--color-primary-login);
    color: var(--color-primary-login-contrast);
    font-weight: 700;
    border-radius: 5px;
    border: none;
  }
}
</style>
